import React from 'react';
import { Skeleton } from 'antd';
import { useGetOperatorsPerPlatform } from 'hooks/capacityManagementQueries';
import { InstancePlatform } from 'types/cluster';
import { CloudProviderItem } from 'types/capacityManagement.types';
import CloudCapacityManagementTable from 'components/guidance/CloudCapacityManagement/CloudCapacityManagementTable/CloudCapacityManagementTable';

function CloudProviderTab({
  cloudProvider,
  showModalForNewSize,
  setShowModalForNewSize,
  initialAdvancedSearchValue,
  showCellEditModal,
  setShowCellEditModal,
  clickedCellValue,
  setClickedCellValue,
  prefillCellData,
  setPrefillCellData,
  canEdit,
}: Readonly<{
  cloudProvider: CloudProviderItem;
  showModalForNewSize: boolean;
  setShowModalForNewSize: React.Dispatch<React.SetStateAction<boolean>>;
  initialAdvancedSearchValue?: string;
  showCellEditModal: boolean;
  setShowCellEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  clickedCellValue: any;
  setClickedCellValue: React.Dispatch<React.SetStateAction<any>>;
  prefillCellData: any;
  setPrefillCellData: React.Dispatch<React.SetStateAction<any>>;
  canEdit: boolean;
}>) {
  const {
    data: operatorsPerPlatformResult,
    isLoading: isOperatorsPerPlatformLoading,
    isError: hasOperatorsPerPlatformError,
  } = useGetOperatorsPerPlatform({
    platform:
      cloudProvider.key as InstancePlatform,
  });

  const operatorsPerPlatform =
    operatorsPerPlatformResult?.data?.platformOperators ?? [];

  if (isOperatorsPerPlatformLoading) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  } else if (hasOperatorsPerPlatformError) {
    return <>Something went wrong</>;
  } else {
    return (
      <CloudCapacityManagementTable
        cloudProviderID={cloudProvider.id}
        cloudProviderKey={cloudProvider.key}
        operatorsPerPlatform={operatorsPerPlatform}
        showModalForNewSize={showModalForNewSize}
        setShowModalForNewSize={setShowModalForNewSize}
        initialAdvancedSearchValue={initialAdvancedSearchValue}
        showCellEditModal={showCellEditModal}
        setShowCellEditModal={setShowCellEditModal}
        clickedCellValue={clickedCellValue}
        setClickedCellValue={setClickedCellValue}
        prefillCellData={prefillCellData}
        setPrefillCellData={setPrefillCellData}
        canEdit={canEdit}
      />
    );
  }
}

export default CloudProviderTab;
